import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ConstantsService {


    public creator_id = '';
    public bridgeStack: any[] = [];
    public allAppUsers: any[] = [];
    public userData: any[] = [];
    public admins = [1, 39, 7, 13, 14, 3, 6, 25, 92, 98, 129];
    public user_token = '';
    public isAdmin = false;

    constructor() {
    }

    setToken(data) {
        this.user_token = typeof data == "string" ? data : data.toString();
    }

    setCreator(data) {
        if (typeof data !== "string") {
            data = data.toString();
        }
        if (data.toLowerCase() == data.toUpperCase() && data !== '') {
            this.creator_id = data;
            this.isAdmin = (this.admins.indexOf(+this.creator_id) > -1);
        }

        if (typeof data === "string") {
            localStorage.setItem('userId', data);
        }
    }

    setUsers(data) {
        this.allAppUsers = data;
    }

    setUser(data) {
        this.userData = data;
    }

    public getAdmins() {
        return this.admins;
    }

    public getLoggedInUserId() {
        this.creator_id = localStorage.getItem('userId')
        return parseInt(this.creator_id, 10);
    }

    public getUserData() {
        return this.userData;
    }

    public getAdminStatus() {
        return this.isAdmin;
    }
}
